
const headers = [
    {
      label: 'ชื่อ - นามสกุล',
      field: 'fullname',
    },
    {
      label: 'อีเมล',
      field: 'email',      
    },
    {
      label: 'เบอร์โทรศัพท์',
      field: 'tel', 
    },
    {
      label: 'Action',
      field: 'action',
      tdClass: 'text-center',
    },
  ]

  export default headers